module.exports = __webpack_public_path__ + "media/images/client/favicons/icon-256x256-e83c5f33eede676dbf0bc5aa7439e9c2.png";